import { render, staticRenderFns } from "./PoliticalRegulations.vue?vue&type=template&id=69113fd1&scoped=true"
import script from "./PoliticalRegulations.vue?vue&type=script&lang=js"
export * from "./PoliticalRegulations.vue?vue&type=script&lang=js"
import style0 from "./PoliticalRegulations.vue?vue&type=style&index=0&id=69113fd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69113fd1",
  null
  
)

export default component.exports